import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { TenantProvider } from "@/contexts/TenantContext";
import { installerOuverturePdfMobile } from "@/utils/pdfMobile";
import GlobalPdfViewer from "@/components/ui/GlobalPdfViewer";
import GlobalHtmlViewer from "@/components/ui/GlobalHtmlViewer";
import GlobalDocxViewer from "@/components/ui/GlobalDocxViewer";
import GlobalOfficeViewer from "@/components/ui/GlobalOfficeViewer";

// Rend l'ouverture des PDF compatible avec la webview mobile (Capacitor) à
// l'échelle de l'app — voir utils/pdfMobile.js. No-op sur desktop / web.
installerOuverturePdfMobile();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
    {/* Visionneuse PDF in-app globale (aperçu + Partager/Imprimer) sur mobile. */}
    <GlobalPdfViewer />
    {/* Visionneuses in-app globales : texte rédigé (HTML assaini) et Word (.docx). */}
    <GlobalHtmlViewer />
    <GlobalDocxViewer />
    {/* Formats Office (.doc, .xls, .ppt…) : visionneuse en ligne de Microsoft. */}
    <GlobalOfficeViewer />
  </React.StrictMode>,
);
